import { render, staticRenderFns } from "./LoaderIcon.vue?vue&type=template&id=6df04f5e&scoped=true&"
import script from "./LoaderIcon.vue?vue&type=script&lang=js&"
export * from "./LoaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df04f5e",
  null
  
)

export default component.exports